import { legacyUrl } from "@/utils/applicationUrls"

export const LOBBY_DISPLAY_PATH = "/program_members/current.tv"

export function redirectToLegacyLobbyDisplay(_to, _from, _next, location = window.location) {
	const target = legacyUrl(LOBBY_DISPLAY_PATH)
	location.replace(target)
	return target
}
